// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","filterListArea":"_24x7fGglVQyn2vcAwak1NA","filterListItemArea":"Gc3lLqLsboxSzmS6wlpHi","title":"_1uFX8DKzmtoo7oq3XaSCY1"};